"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

const LINKS = [
  { href: "/", key: "home" },
  { href: "/search", key: "findMentor" },
  { href: "/terms", key: "terms" },
  { href: "/safety", key: "safety" },
  { href: "/privacy", key: "privacy" },
  { href: "/refunds", key: "refunds" },
] as const;

export function Footer() {
  const t = useTranslations("footer");
  return (
    <footer
      className="mt-auto border-t"
      style={{
        background: "var(--color-surface)",
        borderColor: "var(--color-border)",
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <span
            className="font-bold text-base tracking-tight"
            style={{ color: "var(--color-text)" }}
          >
            Mentrix
          </span>
          <p className="mt-1 text-xs" style={{ color: "var(--color-subtle)" }}>
            {t("tagline")}
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {LINKS.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-xs transition-colors hover:opacity-70"
              style={{ color: "var(--color-muted)" }}
            >
              {t(link.key)}
            </Link>
          ))}
        </nav>

        <p className="text-xs" style={{ color: "var(--color-subtle)" }}>
          © {new Date().getFullYear()} Mentrix
        </p>
      </div>
    </footer>
  );
}
